import { memo, useEffect } from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { useThemeMode } from '@/app/hooks/useThemeMode';
import { useFeatureFlag } from '@/app/useFeatureFlag';
import { FeatureFlags } from '@/app/featureFlags';

interface DarkModeToggleProps {
  className?: string;
}

const DarkModeToggle = (props: DarkModeToggleProps) => {
  const { className } = props;
  const isDarkModeEnabled = useFeatureFlag(FeatureFlags.DarkMode, false);
  const { isDark, toggleThemeMode, setThemeMode } = useThemeMode();

  // Force light mode when feature is disabled
  useEffect(() => {
    if (!isDarkModeEnabled) {
      setThemeMode('light');
    }
  }, [isDarkModeEnabled, setThemeMode]);

  // Hide toggle when feature is disabled
  if (!isDarkModeEnabled) {
    return null;
  }

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'} placement='bottom'>
      <IconButton
        onClick={toggleThemeMode}
        className={clsx('w-40 h-40', className)}
        size='large'
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDark ? (
          <FuseSvgIcon>heroicons-outline:sun</FuseSvgIcon>
        ) : (
          <FuseSvgIcon>heroicons-outline:moon</FuseSvgIcon>
        )}
      </IconButton>
    </Tooltip>
  );
};

export default memo(DarkModeToggle);
